import { render, staticRenderFns } from "./MemberData.vue?vue&type=template&id=6b3adafb&scoped=true&"
import script from "./MemberData.vue?vue&type=script&lang=js&"
export * from "./MemberData.vue?vue&type=script&lang=js&"
import style0 from "./MemberData.vue?vue&type=style&index=0&id=6b3adafb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3adafb",
  null
  
)

export default component.exports